<script>
import Switches from "vue-switches";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      treatment: []
    }
  },
  components: { Switches },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$axios.get(`/room/${this.$route.params.id}/treatment`)
        .then( response => {  
            this.treatment = response.data.result.treatments 
            console.log(this.treatment)
        })
    },
    cheked(val){
      console.log(val)

    },
    onSubmit() {
      let param = new FormData()
      this.treatment.forEach( item => { 
        if(item.isPresent === true) {  
          console.log(item.treatmentId)
          // param.append('treatments[]', item.treatmentId)
           param.append('treatments', item.treatmentId)
        }
      })
      this.$axios.put(`/room/${this.$route.params.id}/treatment`, param)
        .then( () => { 
          Swal.fire("Success", "Treatment Assign to Room Updated Successfully", "success");
        })
    }
  }
}
</script>

<template>
  <div id="edit-location">
    <div class="table-responsive mb-0">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%">No</th>
            <th style="width: 85%">Name</th>
            <th style="width: 10%">Applicable</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in treatment" :key="index">
            <th scope="row">{{ index+1 }}</th>
            <td>{{ item.name }}</td>
            <td>
              <switches v-model="item.isPresent" type-bold="false" color="warning" class="ml-1 mb-0"></switches>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" @click="onSubmit" class="btn btn-primary m-1 float-right">Submit Change</button>
    </div>
  </div>
</template>